import createFetchClient, { Client } from "openapi-fetch";
import createClient from "openapi-react-query";
import { createContext, ReactNode, useContext, useMemo } from "react";

import { $api } from "@/api/api";
import { paths } from "@/api/v1";
import { BASE_PATH } from "@/utils/constants/api";

import { ApiTokenContext } from "../api-token/ApiContextWrapper";
const AuthApiContext = createContext<{
  // Token is valid for 1h, long-term-token is valid for 180 days
  $authApi: typeof $api | null;
  fetchClient: Client<paths, `${string}/${string}`> | null;
  $api: typeof $api;
}>({
  $api,
  $authApi: null,
  fetchClient: null,
});
function AuthApiProvider({ children }: { children: ReactNode }) {
  const { token } = useContext(ApiTokenContext),
    creds = useMemo(() => {
      if (token) {
        const fetchClient = createFetchClient<paths>({
          baseUrl: BASE_PATH,
          headers: { Authorization: `Bearer ${token}` },
        });
        return { $authApi: createClient(fetchClient), fetchClient };
      }
      return null;
    }, [token]);
  return (
    <AuthApiContext.Provider value={{ $api, $authApi: creds?.$authApi??null, fetchClient: creds?.fetchClient??null }}>
      {children}
    </AuthApiContext.Provider>
  );
}

export function useApi() {
  const context = useContext(AuthApiContext);
  return context;
}

export { AuthApiContext, AuthApiProvider };
